import React from 'react';
import { ReactElement } from 'react';
import { Cases } from '../rules/Cases';
import { BaseTab } from './BaseTab';

export const CasesTab = (): ReactElement => {
  return (
    <BaseTab>
      <Cases />
    </BaseTab>
  );
};
